import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';

import './ConfirmActionModal.less';


function ConfirmActionModal({ copy, onConfirmAction, hideModalFn }) {
  const { dek, warning, buttonText } = copy;
  return (
    <div id="confirm-action-modal">
      <div className="modal-header">
        <h3>Wait a sec!</h3>
      </div>
      <div className="modal-body">
        <p style={{ marginBottom: '10px' }}>
          {dek}
        </p>
        <p style={{ color: '#C7133E', fontWeight: '700' }}>
          {warning}
        </p>
        <div className="modal-actions">
          <ButtonV2 variant="secondary" onClick={onConfirmAction}>
            {buttonText}
          </ButtonV2>
          <ButtonV2 onClick={hideModalFn}>
            Cancel
          </ButtonV2>
        </div>
      </div>
    </div>
  );
}

ConfirmActionModal.propTypes = {
  copy: PropTypes.shape({
    dek: PropTypes.string,
    warning: PropTypes.string,
    buttonText: PropTypes.string,
  }),
  onConfirmAction: PropTypes.func,
  hideModalFn: PropTypes.func,
};


export default ConfirmActionModal;



// WEBPACK FOOTER //
// ./src/components/common/modals/ConfirmActionModal/ConfirmActionModal.jsx